import {ref} from "vue";

const STORAGE_KEY = 'eodsun:audioDisabled';

export const audioEnabled = ref(true);

export function toggleAudio() {
    audioEnabled.value = !audioEnabled.value;
    if (audioEnabled.value) {
        sessionStorage.removeItem(STORAGE_KEY);
    } else {
        sessionStorage.setItem(STORAGE_KEY, '1');
    }
}

if (sessionStorage.getItem(STORAGE_KEY) === '1') {
    audioEnabled.value = false;
}
